import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  toggle(event) {
    event.preventDefault()
    this.menuTarget.classList.contains("hidden") ? this.open() : this.hide()
  }

  open() {
    this.menuTarget.classList.remove("hidden")
    if (this.nativeApp) document.body.classList.add("overflow-hidden")
  }

  hide() {
    this.menuTarget.classList.add("hidden")
    this.comment?.classList.remove("review-comment--pressed")
    if (this.nativeApp) document.body.classList.remove("overflow-hidden")
  }

  hideOnBackdrop(event) {
    if (event.target === this.menuTarget) this.hide()
  }

  hideOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.hide()
  }

  hideOnEscape(event) {
    if (event.key === "Escape") this.hide()
  }

  get comment() {
    return this.element.closest(".review-comment")
  }

  get nativeApp() {
    return document.body.dataset.nativeApp === "true"
  }
}
